export const toFahrenheit = Celsius => {
  return Celsius * (9 / 5) + 32
}

export const toCelsius = Fahrenheit => {
  return +((Fahrenheit - 32) / (9 / 5)).toFixed(1)
}
